import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import SearchField from "../SearchField/SearchField";
import SPQSFormGroup from "./SPQSFormGroup";
import Incoterms from "../Misc/Incoterms";
import useSPQS from "../../hooks/useSPQS";
import useSPQSUndo from "../../hooks/useSPQSUndo";
import { handleInputSelect, addEdits, ignoreEnter } from "./utils/inputhandlers";
import useGlobalParams from "../../hooks/useGlobalParams";

const QSSPDelivery = ({ showinfo, setShowinfo, clearfield }) => {
  // Load context values
  const { SPQS, setSPQS, setSPQSData, whdataSP } = useSPQS();
  const { SPQSEdits, editIDSPQS, setEditIDSPQS, undoListSPQS } = useSPQSUndo();
  const { globalparams } = useGlobalParams();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      SPQSEdits,
      editIDSPQS,
      setEditIDSPQS,
      setSPQS,
      setSPQSData,
      addEdits,
      undoListSPQS,
      origin,
      destination,
      globalparams
    );
  };
  return (
    <>
      <fieldset>
        <legend>Delivery:</legend>
        {SPQS.qstype === 2 ? (
          <SPQSFormGroup
            readOnly={SPQS.qstype === 2}
            labelname={"P Incoterm"}
            inputname={"pincoterm"}
            inputtype={"text"}
            cplaceholder={"P Incoterm..."}
            required={false}
          />
        ) : (
          <>
            <div className='form-group' style={{ overflow: "visible" }}>
              <label
                className='pincoterm-container'
                onMouseEnter={(e) => {
                  setShowinfo("pincoterm");
                }}
                onMouseLeave={(e) => {
                  setShowinfo("");
                }}
              >
                P Incoterm: <FontAwesomeIcon icon={faCircleInfo} style={{ cursor: "pointer" }} />
                {showinfo === "pincoterm" && (
                  <div
                    className='pincoterminfo'
                    onMouseEnter={(e) => {
                      setShowinfo("pincoterm");
                    }}
                    onMouseLeave={(e) => {
                      setShowinfo("");
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "2rem" }}>
                      <FontAwesomeIcon icon={faCircleInfo} style={{ color: "var(--purple)", marginRight: "0.5rem" }} />
                      <p> Info</p>
                    </div>
                    <p style={{ width: "100%", paddingBottom: "1rem", borderBottom: "1px dashed gray" }}>
                      Enter the Purchase Incoterm.
                    </p>
                    <Incoterms />
                  </div>
                )}
              </label>

              <SearchField
                required={true}
                searchURL='/api/qs/getpincoterms'
                value={SPQS?.pincoterm || ""}
                valueName='pincoterm'
                valueID='pincotermID'
                customplaceholder='P Incoterm'
                onItemSelect={(item) => localHandleInputSelect(item, "pincoterm", "pincoterm")}
                clearfield={clearfield}
              />
            </div>
          </>
        )}
        <div className='form-group' style={{ overflow: "visible" }}>
          <label
            className='pincoterm-container'
            onMouseEnter={(e) => {
              setShowinfo("sincoterm");
            }}
            onMouseLeave={(e) => {
              setShowinfo("");
            }}
          >
            D Incoterm: <FontAwesomeIcon icon={faCircleInfo} style={{ cursor: "pointer" }} />
            {showinfo === "sincoterm" && (
              <div className='pincoterminfo'>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "2rem" }}>
                  <FontAwesomeIcon icon={faCircleInfo} style={{ color: "var(--purple)", marginRight: "0.5rem" }} />
                  <p> Info</p>
                </div>
                <p style={{ width: "100%", paddingBottom: "1rem", borderBottom: "1px dashed gray" }}>
                  Enter the Delivery Incoterm.
                </p>
                <Incoterms />
              </div>
            )}
          </label>
          <SearchField
            required={true}
            searchURL='/api/qs/getsincoterms'
            value={SPQS?.sincoterm || ""}
            valueName='sincoterm'
            valueID='sincotermID'
            customplaceholder='D Incoterm'
            onItemSelect={(item) => localHandleInputSelect(item, "sincoterm", "sincoterm")}
            clearfield={clearfield}
          />
        </div>
        <SPQSFormGroup type={"date"} labelname={"From"} inputname={"shipfrom"} inputtype={"text"} />
        <SPQSFormGroup type={"date"} labelname={"To"} inputname={"shipuntil"} inputtype={"text"} />
        {SPQS.qstype !== 2 && (
          <div className='form-group'>
            <label>POL:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getlports'
              value={SPQS?.POL || ""}
              valueName='POL'
              valueID='POLID'
              customplaceholder='POL'
              onItemSelect={(item) => localHandleInputSelect(item, "POL", "POL")}
              clearfield={clearfield}
            />
          </div>
        )}
        {SPQS.qstype !== 2 && (
          <div className='form-group'>
            <label>POD:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getdports'
              value={SPQS?.POD || ""}
              valueName='POD'
              valueID='PODID'
              customplaceholder='POD'
              onItemSelect={(item) => localHandleInputSelect(item, "POD", "POD")}
              clearfield={clearfield}
            />
          </div>
        )}
      </fieldset>
      {SPQS.qstype == 2 && (
        <fieldset>
          <legend>Storage:</legend>

          <div className='form-group'>
            <label>Warehouse:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdataSP?.["warehouse"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Fixed Cost:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdataSP ? "$" + whdataSP?.["whfixedcost"].toFixed(2) : ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Variable Cost:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdataSP ? "$" + whdataSP?.["whvarcost"].toFixed(2) : ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Grace Period (days):</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdataSP?.["whgraceperiod"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Accrual Period (days):</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdataSP?.["whaccrualperiod"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>WH Entry Date:</label>
            <input
              readOnly
              disabled
              type={"date"}
              style={{ border: "none", marginTop: "2rem" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdataSP?.["whentrydate"] || ""}
              tabIndex={-1}
            />
          </div>
          <SPQSFormGroup type={"date"} labelname={"WH Exit Date"} inputname={"whexit"} inputtype={"text"} />
          <div className='form-group'>
            <label>Eff. Days in Storage:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdataSP?.["daysinstorage"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
        </fieldset>
      )}
    </>
  );
};

export default QSSPDelivery;
